module.exports = __webpack_public_path__ + "img/pleat depth.e8a085b9.png";